import styled from 'styled-components';

export const StyledOutletWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 80px); //admin nav height

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 60px;
    }
`;
export const GameOutletWrapper = styled.div`
    display: flex;
    flex-direction: column;
    h1 {
        margin: 5px 0;
        line-height: 1.2;
        font-size: 30px;
        font-weight: 900;
        letter-spacing: -1.2px;
    }
`;
export const StyledNav = styled.nav`
    width: 100%;
    display: flex;
    padding: 20px 60px 0;
`;

export const LinkWrapper = styled.div`
    display: flex;
    align-items: center;
`;
